const styles = {
    matchBlock: {
      marginBottom: '48px',
      padding: '0px 24px 48px 20px',
      boxSizing: 'border-box',
      overflow: 'visible',
      //boxShadow: '5px 5px 12px rgba(0, 0, 0, 0.6)'
    },
    matchHeader: {
      position: 'relative',
    },
    showRefDoc1: {
      background: 'none',
      border: 'none',
      color: 'white',
      fontStyle: 'italic',
      textDecoration: 'underline',
      padding: '6px 0px'
    },
    showRefDoc2: {
      background: 'none',
      border: 'none',
      color: 'black',
      fontStyle: 'italic',
      textDecoration: 'underline',
      padding: '6px 0px'
    },
    crossColumnMath: {
      display: 'flex',
      position: 'absolute',
      width: '50%',
      justifyContent: 'center',
      fontSize: 13,
      color: '#444',
      margin: '12px 0 0 0',   
      left: 'calc(25%)',      
    },
    
    statusIcon: {
      position: 'absolute',
      top: -16,
      left: -16,
      transform: 'none',
      width: 34,
      height: 'auto',
      zIndex: '9999'
    },
    userModifiedIcon: {
      position: 'absolute',
      top: -16,
      right: -16,
      transform: 'none',
      width: 32,
      height: 'auto',
      zIndex: '9999'
    },
    matchDetails: {
      display: 'flex',
      gap: 0,
      marginTop: 8,
      boxSizing: 'border-box',
      overflow: 'visible',
    },
    docBlock: {
      display: 'flex',
      width: '50%',
      boxSizing: 'border-box'
    },
    doc1: {
      backgroundColor: '#f9f9f9',
    },
    doc2: {
      backgroundColor: '#e9e9ff',
    },
    doc1InfoContainer: {
      width: '40%',
      padding: 16,
      backgroundColor: '#42999d',
    },
    li1InfoContainer: {
      width: '60%',
      padding: 16,
      backgroundColor: '#49a7ab'
    },
    doc2InfoContainer: {
      width: '40%',
      padding: 16,
      backgroundColor: '#e5e9e8',
    },
    li2InfoContainer: {
      width: '60%',
      padding: 16,
      backgroundColor: '#f2f2f2'
    },
    docLine: {
      margin: 0,
      padding: '2px 0',
      fontSize: 14,
      lineHeight: 1.4,
    },
    headerRow: {
      display: 'flex',
      fontWeight: 'bold',
      marginBottom: 4,
    },
    valueRow: {
      display: 'flex',
      flexDirection: 'column'
    },
    valueCell: {
      padding: '6px 0px',
      fontSize: 18,
      fontWeight: '600',
      lineHeight: 1.4,
    },
    valueColor1: {
      color: 'white',
      fontWeight: '900'
    },
    valueColor2: {
      color: '#425158',
      fontWeight: '900'
    }
  };
  export default styles;
